export default __webpack_public_path__ + "static/media/W1.9a5912ed.png";